import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ChatComponent from './Chat/ChatComponent';
import PortfolioPage from './Portfolio/PortfolioPage';
import { ChatRecoveryProvider } from './state/ChatRecoveryContext';
import { AuthProvider } from './state/AuthContext';
import { CapabilitiesProvider, useCapabilities } from './state/CapabilitiesContext';
import AdminRoute from './Admin/Components/AdminRoute';
import AdminLayout from './Admin/AdminLayout';
import ThreadList from './Admin/ThreadList';
import ThreadDetail from './Admin/ThreadDetail';
import ProposalsList from './Admin/ProposalsList';

function ChatRoute() {
  const capabilities = useCapabilities();
  if (capabilities.loading && !capabilities.extendedChat) return <p role="status">Checking availability…</p>;
  if (!capabilities.extendedChat) return <Navigate to="/" replace />;
  return <AuthProvider><div className="h-screen bg-gray-900 text-gray-100">
    <ChatComponent /></div></AuthProvider>;
}
export default function App() {
  return <BrowserRouter><ChatRecoveryProvider><CapabilitiesProvider><Routes>
    <Route path="/" element={<PortfolioPage />} />
    <Route path="/chat" element={<ChatRoute />} />
    <Route path="/chat/:chatId" element={<ChatRoute />} />
    <Route path="/admin" element={<AuthProvider><AdminRoute><AdminLayout /></AdminRoute></AuthProvider>}>
      <Route index element={<ThreadList />} />
      <Route path="threads/:threadId" element={<ThreadDetail />} />
      <Route path="proposals" element={<ProposalsList />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></CapabilitiesProvider></ChatRecoveryProvider></BrowserRouter>;
}
